export const addressComponentList = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
}

// This is the autocomplete callback used by `https://maps.googleapis.com/maps/api/js`
// It works with the assumption that some inputs have specific ids (eg: 'address', 'address_check', etc..)
export const addressAutocomplete = function () {
    const inputAddress = document.querySelector('#address')

    // Create the autocomplete object, restricting the search predictions to geographical location types.
    let autocomplete = new google.maps.places.Autocomplete(inputAddress, {
        types: ['geocode']
    }) // Avoid paying for data that you don't need by restricting the set of place fields that are returned to just the address components.

    autocomplete.setFields(['address_component']) // When the user selects an address from the drop-down, populate the address fields in the form.

    autocomplete.addListener('place_changed', () => {
        // Get the place details from the autocomplete object.
        const place = autocomplete.getPlace()

        if (typeof place.address_components !== 'undefined') {
            document.querySelector('#address_check').value = inputAddress.value

            // Creating a custom event for `stepAddressBind` to catch the address change via Google autocomplete feature
            const eventAddressChanged = new CustomEvent('address_change')
            document.querySelector('#address').dispatchEvent(eventAddressChanged)

            for (const component of place.address_components) {
                for (const type of component.types) {
                    //if type is undefined or empty, skip it
                    if (typeof type === 'undefined' || type === '') {
                        continue
                    }
                    let addressType = type;

                    if (addressType === "sublocality_level_1") {
                        //sometimes the `locality` is not set
                        addressType = "locality";
                    }

                    if (addressComponentList[addressType]) {
                        document.querySelector("#" + addressType).value =
                            component[addressComponentList[addressType]];
                    }
                }
            }
        }
    })
}
